'use client'
import { useLocaleStore } from '@/hooks/useLocaleStore'
import type { Locale } from './config'

export function useLocale(): Locale {
  return useLocaleStore((s) => s.locale)
}

export function useSetLocale() {
  return useLocaleStore((s) => s.setLocale)
}

export function detectBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') return 'es'
  return navigator.language.toLowerCase().startsWith('en') ? 'en' : 'es'
}
